import { render, staticRenderFns } from "./intendCustomer.vue?vue&type=template&id=6d224663&scoped=true&"
import script from "./intendCustomer.vue?vue&type=script&lang=js&"
export * from "./intendCustomer.vue?vue&type=script&lang=js&"
import style0 from "./intendCustomer.vue?vue&type=style&index=0&id=6d224663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d224663",
  null
  
)

export default component.exports